import React from 'react'
import Manager from '../../public/components/Manager'
import PurchaseBatchAcceptanceDiv from './PurchaseBatchAcceptanceDiv'
Ext.require('Ext.Toast')
const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length

const config = () => {
    const handelBatchAcceptance = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }, type) => {
        const list = selected && selected.map(o => o.data.id) || []
        Tyan.pubForm.showDialog(type, props => <PurchaseBatchAcceptanceDiv {...props} type={type} list={list} onSave={refreshPage} />)
    }
    return {
        multiSelect: true,
        buttons: [
            { text: '验收...', handler: that => handelBatchAcceptance(that, '验收'), disabled: disableBatch },
            { text: '不予验收...', handler: that => handelBatchAcceptance(that, '不予验收'), disabled: disableBatch }
        ],
        columns: [
            { _text: '物料代码', field: 'MaterialNumber', minWidth: 150, search: true, flex: 1 },
            { _text: '物料名称', field: 'MaterialName', minWidth: 150, flex: 1 },
            { _text: '规格型号', field: 'SpecificationModel', minWidth: 150, flex: 1 },
            { _text: '单位', field: 'Unit', minWidth: 80, flex: 1 },
            { _number: '数量', field: 'NoPurAccQuantity', minWidth: 80, flex: 1 },
            { _date: '建议采购时间', field: 'PoposalPurchaseDate', minWidth: 150, flex: 1 },
            { _text: '用途', field: 'Purpose', minWidth: 150, flex: 1 },
            { _text: '供应商', field: 'Supplier', minWidth: 250, search: true, flex: 1 },
            { _float: '单价', field: 'LCNoTaxUnit', minWidth: 150, flex: 1, format: '0,000.0000' },
            { _text: '税率(%)', field: 'TaxRate', minWidth: 150, flex: 1 },
            { _float: '含税单价', field: 'LCTaxUnit', minWidth: 150, flex: 1, format: '0,000.0000', },
            { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
            { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            { _date: '到货日期', field: 'ArrivalDate', minWidth: 150, flex: 1 },
            { _text: '申请部门', field: 'CreateDep', minWidth: 250, flex: 1 },
            { _text: '请购类别', field: 'RequisitionStatus', minWidth: 150, flex: 1 },
        ],
        onDoubleTap: ({ showDetail, refreshPage }, data) => {
        }
    }
}

export default props => <Manager {...props} config={config} />